export default __webpack_public_path__ + "static/media/mexico-smile.f2fbbbd9.svg";